<div [innerHTML]="commentaryText"></div>
